import {EventsBlock} from 'modules/events/components/EventsBlock';
import {IEvent} from 'modules/wineshops-list/models';
import {FC} from 'react';
import style from './style.module.scss';

interface IProps {
    events: IEvent[];
}

export const WineShopEvents: FC<IProps> = ({events}) => {
    return (
        <div className={style.events}>
            <EventsBlock events={events} />
        </div>
    );
};
